import { EncounterType } from '@hb/shared'
import { createContext, PropsWithChildren, useContext, useState } from 'react'
import { EncounterFormProps } from './types'

interface EncounterFormContextValue<T extends EncounterType> {
  type: T
  includePreVisitContact: boolean
  setIncludePreVisitContact: (include: boolean) => void
}

const EncounterFormContext = createContext<EncounterFormContextValue<EncounterType>>({
  type: EncounterType.ANTEPARTUM,
  includePreVisitContact: false,
  setIncludePreVisitContact: () => {},
})

export const EncounterFormProvider = <T extends EncounterType>({
  children,
  openEncounter,
}: PropsWithChildren<EncounterFormProps<T>>) => {
  const { type } = openEncounter
  const [includePreVisitContact, setIncludePreVisitContact] = useState(false)

  return (
    <EncounterFormContext.Provider
      value={{ type, includePreVisitContact, setIncludePreVisitContact }}>
      {children}
    </EncounterFormContext.Provider>
  )
}
export const useEncounterForm = <T extends EncounterType>() => {
  const context = useContext(EncounterFormContext) as EncounterFormContextValue<T>
  if (!context) {
    throw new Error('useEncounterForm must be used within an EncounterFormProvider')
  }
  return context
}
